import { useTableFilter, useTableServerSideFiltering, useUploadFile } from "@/shared"
import { useFetchReporteHistorico } from "@/shared/actions/erp/reporte-stock-historico.action"
import { GeneralTable } from "@/shared/components/ui"
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs"
import { ReporteStockHistorico } from "@/shared/interfaces/erp/movimiento-inventario/reporte-stock-historico.interface"
import { Grid, IconButton, Tooltip } from "@mui/material"
import { useTableColumnsReporteStock } from "../hook/useTableColumnsReporteStock"
import { Download, Visibility } from "@mui/icons-material"
import { useMemo } from "react"
import { toCsvSeleccion } from "../hook/useReporteStock"


interface ModalStockReporteHistoricoProps {
  openModal: boolean
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  handleDataReporteHistoriso: (data: ReporteStockHistorico) => void
  params?: {
    bodega: string[] | null,
    ubicacion: string[] | null
  }
}

export default function ModalStockReporteHistorico({
  openModal,
  setOpenModal,
  params,
  handleDataReporteHistoriso
}: ModalStockReporteHistoricoProps) {

  const {
    columnsReporteStock
  } = useTableColumnsReporteStock();

  const {
    filterObject,
    columnFilters: columnFiltersReporte,
    setColumnFilters: setColumnFiltersReporte
  } = useTableServerSideFiltering();

  const {
    pagination: paginationReporte,
    setPagination: setPaginationReporte,
  } = useTableFilter();

  const {
    pageIndex: pageIndexReporte,
    pageSize: pageSizeReporte
  } = paginationReporte;


  const queryParams = useMemo(
    () => ({
      ubicaciones_in: toCsvSeleccion(params?.ubicacion),
      bodegas_in: toCsvSeleccion(params?.bodega),
      ...filterObject,
      page: pageIndexReporte + 1,
      page_size: pageSizeReporte,
    }),
    [params,
      pageIndexReporte,
      pageSizeReporte,
      filterObject]
  );

  const {
    data: dataReporteHistorico,
    isLoading: isLoadinReporteHistorico,
    isRefetching: isRefetchingReporteHistorico,
  } = useFetchReporteHistorico({
    enabled: true,
    params: queryParams
  })

  const {
    descargarExcelUrl
  } = useUploadFile()

  return (

    <ScrollableDialogProps
      onCloseIcon={() => {
        setOpenModal(false)
      }}
      open={openModal}
      title="Reporte Histórico"
      minWidth="60%"
      contentNode={
        <Grid container spacing={3}>

          <Grid item xs={12}>
            <GeneralTable<ReporteStockHistorico>
              columns={columnsReporteStock}
              data={dataReporteHistorico?.data.data || []}
              //
              isLoading={isLoadinReporteHistorico}
              isRefetching={isRefetchingReporteHistorico}
              // // search
              enableGlobalFilter={false}
              // onGlobalFilterChange={setGlobalFilter}
              // // pagination
              pagination={paginationReporte}
              onPaging={setPaginationReporte}
              rowCount={dataReporteHistorico?.data?.count}
              // // actions

              ///* filters - server side
              enableManualFiltering={true}
              columnFilters={columnFiltersReporte}
              onColumnFiltersChange={setColumnFiltersReporte}
              enableSorting={false}
              enableColumnActions={true}

              // crud
              positionActionsColumn='first'
              showCustomActionBtnSpace={true}
              canEdit={false}
              //actionsColumnSize={}

              customActionBtnSpace={(value) => {

                return <Grid container>

                  {/* <Grid item>
                    <Tooltip title='Descargar PDF'>
                      <IconButton
                        color="error"
                        onClick={() => {
                          descargarExcelUrl(value.url_excel)
                        }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                  </Grid> */}
                  <Grid item>
                    <Tooltip title='Descargar EXCEL'>
                      <IconButton
                        color="success"
                        onClick={() => {
                          descargarExcelUrl(value.url_excel)
                        }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                  </Grid>

                  <Grid item>
                    <Tooltip title='Ver Reporte Histórico'>
                      <IconButton
                        onClick={() => {
                          handleDataReporteHistoriso(value)
                        }}
                      >
                        <Visibility />
                      </IconButton>
                    </Tooltip>
                  </Grid>



                </Grid>
              }}
            />
          </Grid>

        </Grid>
      }
    />
  )


}